import { useMutation } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useRequestCharter = () => {
  const { token } = useContext(AuthContext);

  const requestCharter = async ({ vesselId, body }) => {
    if (!token) throw new Error("Token is missing");
    if (!vesselId) throw new Error("Vessel ID is required");
    const endpoint = `${process.env.REACT_APP_SERVER_URL}/charter/request/${vesselId}`;
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to request charter");
    }
    return data;
  };

  const mutation = useMutation(requestCharter);
  return mutation;
};

export default useRequestCharter; 